import React from 'react';
import PropTypes from 'prop-types';
import { withPrefix } from 'gatsby';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Link } from '../components/Link';
import { Button } from '../components/Button';

const styles = theme => {
  return {
    root: {},
    lead: {
      margin: [0, 'auto', 16],
      maxWidth: 640,
      textAlign: 'center',
      fontSize: 14,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: theme.color.primary.main
    },
    poster: {
      display: 'block',
      margin: [0, 'auto', 18],
      width: '100%',
      maxWidth: 340
    },
    gallery: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: [0, 'auto', 18],
      maxWidth: 860
    },
    shot: {
      display: 'block',
      margin: 6,
      width: 220,
      height: 140,
      objectFit: 'cover'
    },
    facts: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: [0, 'auto', 18],
      maxWidth: 720,
      textAlign: 'center'
    },
    fact: {
      margin: [0, 14, 10],
      minWidth: 140
    },
    factLabel: {
      display: 'block',
      marginBottom: 4,
      fontFamily: theme.typography.secondary,
      fontSize: 11,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
      color: theme.color.secondary.main
    },
    factValue: {
      display: 'block',
      fontFamily: theme.typography.primary,
      fontSize: 13,
      lineHeight: 1.35,
      color: theme.color.heading.main
    },
    actions: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: [0, 'auto', 22]
    },
    action: {
      margin: [0, 8, 10]
    },
    menu: {}
  };
};

class Component extends React.Component {
  onLinkStart = (event, { isInternal }) => {
    if (isInternal) {
      this.secuenceElement.exit();
    }
  }

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence ref={ref => (this.secuenceElement = ref)}>
            <p className={classes.lead}>
              <Text>Una voz que marcó toda una generación</Text>
            </p>
            <img
              className={classes.poster}
              src={withPrefix('/images/yoko-poster.jpg')}
              alt='Póster oficial de Yoko Takahashi, New Genesis Latam Tour, en Costa Rica'
            />
            <div className={classes.gallery}>
              <Link href='/concierto' onLinkStart={this.onLinkStart}>
                <img className={classes.shot} src={withPrefix('/images/hero-yoko.webp')} alt='Retrato de Yoko Takahashi del afiche oficial' />
              </Link>
              <Link href='/concierto' onLinkStart={this.onLinkStart}>
                <img className={classes.shot} src={withPrefix('/images/palacio.jpg')} alt='Palacio de los Deportes en Heredia' />
              </Link>
              <Link href='/vinilo' onLinkStart={this.onLinkStart}>
                <img className={classes.shot} src={withPrefix('/images/vinilo.jpg')} alt='Vinilo de edición limitada, 40 copias por país' />
              </Link>
            </div>
            <div className={classes.facts}>
              <div className={classes.fact}>
                <span className={classes.factLabel}>Fecha</span>
                <span className={classes.factValue}>Sáb 21 nov</span>
              </div>
              <div className={classes.fact}>
                <span className={classes.factLabel}>Recinto</span>
                <span className={classes.factValue}>Palacio de los Deportes, Heredia</span>
              </div>
              <div className={classes.fact}>
                <span className={classes.factLabel}>Apertura</span>
                <span className={classes.factValue}>12:00 md</span>
              </div>
              <div className={classes.fact}>
                <span className={classes.factLabel}>Preventa</span>
                <span className={classes.factValue}>Fase 1 activa</span>
              </div>
            </div>
            <div className={classes.actions}>
              <Link className={classes.action} href='https://www.omticket.com/' target='omticket'>
                <Button>Comprar entradas</Button>
              </Link>
              <Link className={classes.action} href='/gira' onLinkStart={this.onLinkStart}>
                <Button>Ver la gira</Button>
              </Link>
            </div>
        </Secuence>
      </Main>
    );
  }
}

Component.propTypes = {
  classes: PropTypes.any.isRequired
};

export default withStyles(styles)(Component);
